import { transformNumberToRating } from '../transformNumber';
import { transformStringToNumber } from './transformStringToNumber';

export const transformStringToRating = ({
  stringValue,
  ratingMax,
}: {
  stringValue: string;
  ratingMax: number;
}): number | null => {
  const numberValue = transformStringToNumber(stringValue);
  return numberValue === null ? null : transformNumberToRating({ numberValue, ratingMax });
};
